<template>
  <div class="fullscreen text-white text-center flex flex-center">
    <div>
      <div style="font-size: 30vh">
        404
      </div>

      <div class="text-h2 mb-14" style="opacity:.4">
        Oops. Nada por aquí...
      </div>

      <v-btn
        unelevated
        to="/"
        class='mt-14'
        dark
      >
        Regresar al inicio
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error404'
}
</script>
